import React from "react";
import PropTypes from "prop-types";
import idx from "idx";
import { unTrailingSlashIt } from "trailing-slash-it";
import { TABS_MAP } from "your_projects/constants";
import TabbedNavigation from "common/components/tabbed_navigation";

const ProjectTypeTabs = ({ counts, params, router, push }) => {
  const links = Object.keys(TABS_MAP?.[params.userType] || {}).map((key) => {
    const item = TABS_MAP[params.userType][key];
    const tab = unTrailingSlashIt(item.url).split("/").slice(-1)[0];
    const count = idx(counts, (_) => _[params.userType][tab]) || 0;
    const showIcon = item.showIconIfNotEmpty && count > 0;

    return {
      url: item.url,
      name: (
        <span>
          {showIcon && <i className="fa-solid fa-envelope" />} {item.name} (
          {count})
        </span>
      ),
    };
  });

  return <TabbedNavigation tabs={{ links }} router={router} push={push} />;
};

ProjectTypeTabs.propTypes = {
  counts: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  push: PropTypes.func.isRequired,
};

export default ProjectTypeTabs;
